import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("ls_token"));
  const [email, setEmail] = useState(() => localStorage.getItem("ls_email"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const r = await api.get("/auth/me");
        setEmail(r.data.email);
      } catch {
        localStorage.removeItem("ls_token");
        localStorage.removeItem("ls_email");
        setToken(null);
        setEmail(null);
      }
      setLoading(false);
    };
    verify();
  }, [token]);

  const login = async (em, password) => {
    const r = await api.post("/auth/login", { email: em, password });
    localStorage.setItem("ls_token", r.data.access_token);
    localStorage.setItem("ls_email", r.data.email);
    setToken(r.data.access_token);
    setEmail(r.data.email);
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem("ls_token");
    localStorage.removeItem("ls_email");
    setToken(null);
    setEmail(null);
  };

  return (
    <AuthContext.Provider value={{ token, email, login, logout, loading, isAuthed: !!token }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
